// Modules
import { HighlightedText } from 'Admin/Component/AdFunc';
import DOMPurify from 'dompurify';
import { Link, useLocation } from 'react-router-dom';

// CSS
import '_Asset/css/User/Page/develop.css';

const KmList = ({item, searchVal}) => {

  // Use Hooks
  const location = useLocation();
  const sanitizer = DOMPurify.sanitize;
 
  const path = location.pathname;
  const pathChk = path.split('/')[3];

  // Convert Format
  const FormatConv = (date) => {
    const newDate = new Date(date);

    const month = newDate.toLocaleString("en-US", { month: "short" })
    const dt = newDate.getDate();
    const year = newDate.getFullYear();

    return (month + ' ' + dt + ', ' + year)
  }
  
  return (
    <div className={`kmItem ${pathChk === 'search' ? 'search' : ''}`}>
      <Link to={`/develop/apis-manual/${item.km_grp}/${item.km_id}`}>
        <i className="icofont-file-alt"></i>
        <span dangerouslySetInnerHTML={{ __html: sanitizer(HighlightedText(item.km_title, searchVal))}}></span>
      </Link>
      {
        pathChk === 'search' ?
          <div className="contBox">
            <div className="kmCont" dangerouslySetInnerHTML={{ __html: sanitizer(HighlightedText(item.km_content.replace(/(<([^>]+)>)/ig,""), searchVal))}}></div>
            <span className="contMsg">Create on {FormatConv(item.km_create_date)} - {item.km_grp}</span>
          </div>
        :
          <div className="contBox">
            <span className="contMsg">Revised on {FormatConv(item.km_last_modify_date)}{/* - updated by {item.km_last_modify_user}*/}</span>
          </div>
      }
    </div>
  )
}

export default KmList;